import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 320px;
  height: 110px;
  padding: 24px;

  background: #ffffff;
  border-radius: 8px;
  transition: box-shadow 0.2s;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.12);

  font-family: 'Roboto', sans-serif;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 50%;
    height: 100%;
    padding-top: 24px;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 24px;
    margin-bottom: 16px;
  }
`;

export const Title = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #6a6a6a;
`;

export const Content = styled.div`
  width: 100%;
  height: 22px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 24px;
  color: #000000;
  margin-top: 9px;
`;
